import { HomeContainer } from "../../containers";
import "./Style.scss";

function HomePage() {
  return (
    <div>
      <HomeContainer />
    </div>
  );
}
export default HomePage;
